import React from 'react'
import { MainSection } from './styles/Section.styled'

import { Terminals, Hseq, Lpg, Market, Plants, Pricing, Producers, Refinery, Shipping, Trucking } from '../../../../assets/svgs/svg'


const Section = () => {

  return (
    <MainSection>
      <div className='section__content'>
            <div className='section__header'>
                <h2 className='section__title'>Why choose us</h2>
                <p className='section__desc'>Building a thriving business is hard enough without worrying about overhead. We <br/> are here to ease some of your worries by providing the solutions below</p>
            </div>
            <>{' '}</>

            <div className='section__grid'>

                 <div className='section__gridList'>
                    <div className='section__gridItem'>
                       
                         <div className='section__img one bg'>
                            <Lpg />
                         </div>
                       
                       <div>
                           <h3> LPG News</h3>
                            <p>Current and Past on LPG Industry, social media feed and industry developments.
                            </p>
                        </div>
                    </div>
                    <></>
                 </div>
                   {/* 2 */}
                 <div className='section__gridList'>
                    <div className='section__gridItem'>
                       
                         <div className='section__img two bg'>
                            <Market />
                         </div>
                       
                       <div>
                           <h3> Market</h3>
                            <p>Market Volume by LGA, State Region 
                            etc Presented by Cylinder Type 
                            and bulk
                            </p>
                        </div>
                    </div>
                    <></>
                 </div>
                    {/* 3 */}
                 <div className='section__gridList'>
                    <div className='section__gridItem'>
                       
                         <div className='section__img three bg'>
                            <Plants />
                         </div>
                       
                       <div>
                           <h3>Plants</h3>
                            <p>Spot whole sale and retail pricing 
                            by plants; Nation wide plant 
                            information, Location and capacity 
                            </p>
                        </div>
                    </div>
                    <></>
                 </div>

                   {/* 4 */}

                   <div className='section__gridList'>
                    <div className='section__gridItem'>
                       
                         <div className='section__img four bg'>
                            <Trucking />
                         </div>
                       
                       <div>
                           <h3>Trucking</h3>
                                    <p>Product Movement by Truck, LPG
                                    Logistics cost calculator LPG truck
                                    population and truck type.  
                            </p>
                        </div>
                    </div>
                    <></>
                 </div>

                 {/* 5 */}
                     
                 <div className='section__gridList'>
                    <div className='section__gridItem'>
                       
                         <div className='section__img five bg'>
                            <Refinery />
                         </div>
                       
                       <div>
                           <h3>Refinery</h3>
                            <p>Refinery Operational status and loading activity 
                            </p>
                        </div>
                    </div>
                    <></>
                 </div>
                   {/* 6 */}
            
                   <div className='section__gridList'>
                    <div className='section__gridItem'>
                       
                         <div className='section__img six bg'>
                            <Producers/>
                         </div>
                       
                       <div>
                           <h3>Producer</h3>
                            <p>Production center information by
                            inland and coastal - specifically gas
                            processinng plants. 
                            </p>
                        </div>
                    </div>
                    <></>
                 </div>

                 {/* 7 */}

                 <div className='section__gridList'>
                    <div className='section__gridItem'>
                       
                         <div className='section__img seven bg'>
                            <Shipping />
                         </div>
                       
                       <div>
                           <h3>Shipping</h3>
                            <p>Cargo by Cargo information: Ship call port and jetty information.
                            </p>
                        </div>
                    </div>
                    <></>
                 </div>

                 {/* 8 */}

                 <div className='section__gridList'>
                    <div className='section__gridItem'>
                          
                         <div className='section__img eight bg'>
                            <Terminals />
                         </div>
                       
                       <div>
                           <h3>Terminals</h3>
                            <p>Information on Terminals: Location capacity, operational activity and inventory.
                            </p>
                        </div>
                    </div>
                    <></>
                 </div>

                 {/* 9 */}

                 <div className='section__gridList'>
                    <div className='section__gridItem'>
                       
                    <div className='section__img nine bg'>
                            <Pricing />
                         </div>
                       
                       <div>
                           <h3>Pricing</h3>
                            <p>HGranular market supply and demand pricing information. Demand side presented by wholesale and retail and GPS,LGA,State and Region etc.
                            </p>
                        </div>
                    </div>
                    <></>
                 </div>

                 {/* 10 */}

                 <div className='section__gridList'>
                    <div className='section__gridItem'>
                       
                         <div className='section__img ten bg'>
                            <Hseq />
                         </div>
                       
                       <div>
                           <h3>HSEQ</h3>
                            <p>Spot whole sale and retail pricing by plants; Nation wide plant information, Location and capacity 
                            </p>
                        </div>
                    </div>
                    <></>
                 </div>
                 

            </div>
      </div>
    </MainSection>
  )
}

export default Section